import React, { useState } from 'react'
import LoadingProgress from '../../components/LoadingProgress';
import { Button, makeStyles, Text } from '@fluentui/react-components';
import { ArrowLeftFilled, CheckmarkCircleColor } from '@fluentui/react-icons';
import { EmailInfo, useTabStore } from '../../providers/TabProvider';
import { useResultStore } from '../../providers/ResultProvider';
import { useMutation } from '@tanstack/react-query';
import { reportPhishing } from '../../api';
import { rootUseStyles } from '../../taskpane/fluent-style';
import { parseAIResult } from '../../utils/parseAIResult';


const useStyles = makeStyles({
    main: {
        flex: 1,
        alignContent: "center",
    },

    section: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "25px",
        gap: "5px",
    },
    scanTitle: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },
    scanDescription: {
        paddingLeft: "25px",
        margin: "6px 0",
    },
    spinner: {
        height: "80px",
        width: "80px",
    }

});

export default function ReportPhishing() {
    const setReportSent = useResultStore((s) => s.setReportSent);
    const insightData = useResultStore((s) => s.insightData);
    const deepScanData = useResultStore((s) => s.deepScanData);
    const emailData = useTabStore((s) => s.emailData);
    const parsedAIResult = parseAIResult(insightData?.ai_email_analysis_result);
    const { setActiveTab } = useTabStore();

    const { mutate, isPending, error, } = useMutation({
        mutationFn: async (data: Partial<EmailInfo>) => {
            return await reportPhishing({
                emailData: data,
                status: insightData?.status || "Unrated",
                groupId: deepScanData?.group_id || "",
                aiResult: parsedAIResult
            });
        },
        onSuccess: (data) => {
            console.log(data, "Data from API");
            setReportSent(true);
        },
        onError: (error) => {
            console.error("report-phishing: Error during loading:", error);
        }
    });

    React.useEffect(() => {
        // ! run Immediate if the user is in the report phishing tab
        if (!Office.context.mailbox.item) {
            // ! if the item is not present, the user is not in the report phishing tab
            setActiveTab("ai-insight-result");
            return;
        };

        mutate(emailData);

    }, []);


    return (
        <main className={`${rootUseStyles().root} ${useStyles().main}`}>
            {isPending && (
                <LoadingProgress label='Reporting this email' />
            )}
            {!isPending && (
                <ReportPhishingSuccess />
            )}

        </main>
    )
}


function ReportPhishingSuccess() {
    const { setActiveTab } = useTabStore();


    return (
        <section className={useStyles().section}>
            <div style={{ alignContent: "center" }}>
                <CheckmarkCircleColor style={{ fontSize: "80px", }} />
            </div>
            <Text as="h1" align='center' style={{ fontWeight: 600, fontSize: "20px", margin: "5px 0" }}>Report Submitted</Text>
            <Text as="p" align='center'>Thank you. This email has been successfully reported to AQUILA.</Text>
            <Button
                icon={<ArrowLeftFilled />}
                onClick={() => setActiveTab("ai-insight-result")}
            >
                Back to Scan Results
            </Button>
        </section>
    )
}